import React from "react";
import {LineChartPro} from "@mui/x-charts-pro";
import CCMuiChart from "./CCMuiChart";

class CCLineChart extends CCMuiChart {
    static ATTR_MAP: [string, string][] = [
        ["AxisHighlight", "axisHighlight"],
        ["BrushConfig", "brushConfig"],
        ["Colors", "colors"],
        ["Dataset", "dataset"],
        ["DisableAxisListener", "disableAxisListener"],
        ["DisableLineItemHighlight", "disableLineItemHighlight"],
        ["ExperimentalFeatures", "experimentalFeatures"],
        ["Grid", "grid"],
        ["Height", "height"],
        ["HiddenItems", "hiddenItems"],
        ["HideLegend", "hideLegend"],
        ["HighlightedAxis", "highlightedAxis"],
        ["HighlightedItem", "highlightedItem"],
        ["Id", "id"],
        ["LoadingText", "loadingText"],
        ["Margin", "margin"],
        ["onAreaClick", "onAreaClick"],
        ["onAxisClick", "onAxisClick"],
        ["onHiddenItemsChange", "onHiddenItemsChange"],
        ["onHighlightChange", "onHighlightChange"],
        ["onHighlightedAxisChange", "onHighlightedAxisChange"],
        ["onLineClick", "onLineClick"],
        ["onMarkClick", "onMarkClick"],
        ["onZoomChange", "onZoomChange"],
        ["ShowToolbar", "showToolbar"],
        ["SkipAnimation", "skipAnimation"],
        ["SlotProps", "slotProps"],
        ["Slots", "slots"],
        ["Width", "width"],
        ["ZoomData", "zoomData"],
        ["ZoomInteractionConfig", "zoomInteractionConfig"],
    ];

    renderChart(chartProps: any): React.ReactNode {
        return <LineChartPro {...chartProps} sx={this.props.sx} />;
    }
}

export default CCLineChart;
